const LoadingState = ({ message = "Loading data..." }) => {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center">
        <div className="text-customBlue text-lg font-semibold">{message}</div>
      </div>
    </div>
  );
};

export default LoadingState;
